import React from 'react';
import { SvgIcon } from '@scotia/canvas-react';

export const ReferenceIcon = () => {
  return (
    <SvgIcon color="highlight" iconType="svg-icon" size={24}>
      <g
        id="Act.-renta-desktop"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="04-Comprobante-Copy-2"
          transform="translate(-181.000000, -522.000000)"
        >
          <g id="Group-3" transform="translate(182.000000, 522.000000)">
            <g id="Folder-Icon">
              <path
                d="M21.0259708,6.80298354 L19.9477159,6.80298354 L19.9477159,4.70975783 C19.9477159,4.13255085 19.4641186,3.66314498 18.869461,3.66314498 L11.860804,3.66314498 C11.7346482,3.66314498 11.6128054,3.62023386 11.5157625,3.5422612 L8.43087517,1.04661285 L2.15650983,1.04661285 C1.56185224,1.04661285 1.07825491,1.51601872 1.07825491,2.0932257 L1.07825491,5.75637069 L21.0259708,5.75637069 L21.0259708,6.80298354 L1.07825491,6.80298354 L0,6.80298354 L0,2.0932257 C0,0.938811728 0.967194657,0 2.15650983,0 L8.62603931,0 C8.75219513,0 8.87403794,0.0429111269 8.97108088,0.120883784 L12.0559682,2.61653213 L18.869461,2.61653213 C20.0587762,2.61653213 21.0259708,3.55534386 21.0259708,4.70975783 L21.0259708,6.80298354 Z"
                id="Page-1"
                fill="#BE207A"
              />
              <rect
                id="Rectangle-path"
                stroke="#BE207A"
                fill="#FFFFFF"
                x="0"
                y="5.50331963"
                width="22.7080485"
                height="14.905631"
                rx="2"
              />
            </g>
          </g>
        </g>
      </g>
    </SvgIcon>
  );
};

export const PrintIcon = () => {
  return (
    <SvgIcon color="highlight" iconType="svg-icon" size={24}>
      <svg width="18px" height="17px" viewBox="0 0 18 17" version="1.1">
        <desc>Created with Sketch.</desc>
        <defs>
          <polygon id="path-1" points="0 15.6666667 16 15.6666667 16 0 0 0" />
        </defs>
        <g
          id="Act.-renta-desktop"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <g id="01-Formulario" transform="translate(-661.000000, -625.000000)">
            <g id="Group-6" transform="translate(578.000000, 610.000000)">
              <g id="Group-2" transform="translate(84.000000, 15.000000)">
                <path
                  d="M3.22727273,12.5 L1.18181818,12.5 C0.806818182,12.5 0.5,12.2 0.5,11.8333333 L0.5,5.16666667 C0.5,4.8 0.806818182,4.5 1.18181818,4.5 L14.8181818,4.5 C15.1931818,4.5 15.5,4.8 15.5,5.16666667 L15.5,11.8333333 C15.5,12.2 15.1931818,12.5 14.8181818,12.5 L12.7727273,12.5"
                  id="Stroke-1"
                  stroke="#8230DF"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <polygon
                  id="Stroke-3"
                  stroke="#8230DF"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  points="3.33333333 15.5 12.6666667 15.5 12.6666667 9.5 3.33333333 9.5"
                />
                <mask id="mask-2" fill="white" />
                <g id="Clip-4" />
                <polygon
                  id="Stroke-5"
                  stroke="#8230DF"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  mask="url(#mask-2)"
                  points="3.16666667 4.5 12.5 4.5 12.5 0.5 3.16666667 0.5"
                />
                <path
                  d="M12.5,6.22222222 L13.1666667,6.22222222"
                  id="Stroke-6"
                  stroke="#8230DF"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  mask="url(#mask-2)"
                />
              </g>
            </g>
          </g>
        </g>
      </svg>
    </SvgIcon>
  );
};
